var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C7.5625 5 4 8.59375 4 13C4 17.4375 7.5625 21 12 21C16.4062 21 20 17.4375 20 13C20 8.59375 16.4062 5 12 5ZM12 19.5C8.40625 19.5 5.5 16.5938 5.5 13C5.5 9.4375 8.40625 6.5 12 6.5C15.5625 6.5 18.5 9.4375 18.5 13C18.5 16.5938 15.5625 19.5 12 19.5ZM13.25 15.5H12.75V12.75C12.75 12.3438 12.4062 12 12 12H11C10.5625 12 10.25 12.3438 10.25 12.75C10.25 13.1875 10.5625 13.5 11 13.5H11.25V15.5H10.75C10.3125 15.5 10 15.8438 10 16.25C10 16.6875 10.3125 17 10.75 17H13.25C13.6562 17 14 16.6875 14 16.25C14 15.8438 13.6562 15.5 13.25 15.5ZM12 11C12.5312 11 13 10.5625 13 10C13 9.46875 12.5312 9 12 9C11.4375 9 11 9.46875 11 10C11 10.5625 11.4375 11 12 11Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.86d501da69add19c7511af5716378927.svg";
export { ForwardRef as ReactComponent };